import React, { useContext, useEffect, useState } from 'react';
import "./GRProposalstyle.css";
import Application from '../../../StateContext/Application.js';
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../../public/LoginImages/importimages.js';
import { apiurl } from '../../../../../path.js';
import moment from "moment";
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./GRProposalstyle.css";

const DateInput = ({ name, value, onChange, maxToday, small = false }) => (
  <div
    style={{
      position: "relative",
      width: "100%",
      height: small ? "38px" : "40px",
      border: small ? "1px solid #b9d6f2" : "1px solid #ced4da",
      borderRadius: "6px",
      backgroundColor: "#fff",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
    }}
  >
    <DatePicker
      selected={value ? moment(value, "YYYY-MM-DD").toDate() : null}
      onChange={(d) =>
        onChange({ target: { name, value: d ? moment(d).format("YYYY-MM-DD") : "" } })
      }
      dateFormat="dd/MM/yyyy"
      placeholderText="dd/mm/yyyy"
      maxDate={maxToday ? new Date() : null}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      autoComplete="off"
      portalId="root"
      wrapperClassName="dp-wrapper"
      customInput={
        <input
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
            padding: "0 36px 0 12px",
            fontSize: small ? "12px" : "16px",
          }}
        />
      }
    />
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16" height="16" viewBox="0 0 16 16"
      style={{ position: "absolute", right: "12px", pointerEvents: "none" }}
    >
      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
    </svg>
  </div>
);

const GRProposalCreation = () => {
    const operation = useContext(Application);
    const { GRCreation, GetBudgetHeadInfo, SecureFileFetching, TypesOfWork, GetGramPanchayatCodes, GRProposalCreationFunction ,Usermenu } = operation;
    const { language, toggleLanguage, t } = useLanguage();

    const [HeadInfo, setHeadInfo] = useState([]);
    const [AllDistrict, setAllDistrict] = useState([]);
    const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
    const [gramPanchayat, setgramPanchayat] = useState([])
    const [GPname, setGPname] = useState([])

    const [tableData, setTableData] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [Indexofediting, setIndexofEditing] = useState(null);

    const [totalAmount, setTotalAmount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [getWork, setWork] = useState([]);
    const [WorkId, setWorkId] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
const[RoleID,setroleID]=useState(null)
    const [data, setData] = useState({
        HeadCode: "",
        ProposalYear: "",
        GRNumber: "",
        GRDate: "",
        District: "",
        Taluka: "",
        ConstituencyName: "",
        GramPanchayat: [],
        WorkName: "",
        JobId:"",
        TotalProposalAmount: "",
        ProposalAmount: "",
        ProposalFileNumber: "",
        Area: "",
        Type: "State",
        workType: '',
        isMultipleGp: 'Yes',
        Remark: "",
        workClass: "",
        RoadCategory: "",
        RoadNumber: "",
        ProposalWorkAmount: "",
        proposedLength: '',
        proposalDate: "",
        GRAmount: ""
    });

    // const HandleChangeData = (e) => {
    //     const { name, value } = e.target;

    //     // allow only alphanumeric + space, and no leading space
    //     const cleanedValue = value
    //         .replace(/[^a-zA-Z0-9\u0900-\u097F\s]/g, "")
    //         .replace(/^\s+/, "");

    //     if (name === "GRDate" || name === "proposalDate") {
    //         const formatted = moment(cleanedValue).format("YYYY-MM-DD HH:mm:ss");
    //         console.log("Selected Time --> ", cleanedValue);
    //         console.log("Current Time ---> ", formatted);

    //         setData({
    //             ...data,
    //             [name]: formatted
    //         });
    //         return;
    //     }

    //     setData({
    //         ...data,
    //         [name]: cleanedValue
    //     });
    // };
    
     const getmenu = async () => {
  try {
    const data = await Usermenu();
    if (!data || typeof data !== "object") {
      console.error("Invalid data:", data);
      return;
    }
    const roleID = data?.Data?.RoleID;
      setroleID(roleID)
  console.log("sffdsf",roleID)
  } catch (error) {
    console.error("Error in AdminNavbar getmenu:", error);
  }
};
    const HandleChangeData = (e) => {
        const { name, value } = e.target;

        // ✅ Fix: Remove the restrictive regex. 
        // This only prevents leading spaces but allows all symbols, letters, and numbers.
        const cleanedValue = value.replace(/^\s+/, "");

        if (name === "GRDate" || name === "proposalDate") {
            setData({
                ...data,
                [name]: cleanedValue ? moment(cleanedValue).format("YYYY-MM-DD") : ""
            });
            return;
        }

        setData({
            ...data,
            [name]: cleanedValue
        });
    };

        useEffect(() => {
          if (!RoleID) return;
        
          setData(prev => ({
            ...prev,
            HeadCode:
              RoleID === 25 || RoleID === 24
                ? "3054-2419(Roads and bridge repair maintenance program)"
                : "2515-1238(MLA Representative)"
          }));
        }, [RoleID]);

    const FetchHeadInfo = async () => {
        try {
            let res = await GetBudgetHeadInfo("null", "AllHeadCode");
            console.log("Data i get from Bakcend :: ", res);
            setHeadInfo(res);
        }
        catch (err) {
            console.log(err);
        }
    }

    const FetchGramPanachayatInfo = async () => {
        try {
            let res = await GetBudgetHeadInfo('null', "AllDistrict");
            // console.log("Data i get:: ", res);
            setAllDistrict(res);
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        FetchHeadInfo();
        FetchGramPanachayatInfo();
        getmenu();
    }, []);

    useEffect(() => {
        if (data.District) {
            let res = AllDistrict.filter((item) => item.District_Marathi === data.District);
            setTalukasofDistrict(res);
              setData(prev => ({
            ...prev,
            Taluka: ""
        }));
        }
    }, [data.District]);


    const GetTypesOfWork = async () => {
        console.log(data.HeadCode);
        try {
            let res = await TypesOfWork(data.HeadCode);
            setLoading(true);
            setWorkId(res);
            console.log("Type Of Work :: ", res);
            console.log("Work Class :: ", data.workClass);

            if (data.HeadCode == data.HeadCode) {
                let workNames = res.filter((item) => item.Work_Type === data.workClass);
                console.log("Work Names :: ", workNames);
                setWork(workNames)
            }
            else {
                setWork(res)
            }
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if (data.HeadCode) {
            GetTypesOfWork();
        }
    }, [data.HeadCode, data.workClass, data.workType]);


    const GetGramPanchayat = async () => {
        try {
            let res = await GetGramPanchayatCodes(GPname, "Proposal");
            console.log(GPname);
            console.log("Data of grampanchayat:: ", res)
            // let GramPanchayat = res.filter((item) => item.Development_Block_Name === GPname);
            console.log("Data of grampanchayat:: ", res);
            setgramPanchayat(res);
        }
        catch (err) {
            console.log(err);
        }
    }

    const getEnglishNameOFTaluka = async () => {
        let res = await GetBudgetHeadInfo("null", "GetTalukas");
        let talukaNameEnglish = res.filter((item) => item.ULBNameMarathi === data.Taluka);
        console.log("Data of taluka:: ", talukaNameEnglish);
        if (talukaNameEnglish.length > 0) {
            setGPname(talukaNameEnglish[0].ULBName);
        } else {
            console.warn("No matching Taluka found for Marathi name:", data.Taluka);
            setGPname("");
        }
    }
    useEffect(() => {
        getEnglishNameOFTaluka();
    }, [data.Taluka]);

    useEffect(() => {
        if (GPname) {
            GetGramPanchayat();
        }
    }, [GPname]);



    const AddinTableOperation = (e) => {
        e.preventDefault();

        try {
            console.log("Fucntion Called : ");

            if (!data.GRNumber || !data.GRDate || !data.ProposalYear || !data.HeadCode || !data.District || !data.Taluka || !data.ConstituencyName || !data.isMultipleGp || !data.workClass || !data.workType || !data.WorkName || !data.RoadCategory || !data.RoadNumber || !data.proposedLength || data.GramPanchayat.length <= 0 || !data.ProposalAmount || !data.ProposalFileNumber || !data.proposalDate|| !data.JobId  ) {
                return alert("Please fill all fields before adding!");
            }

            if (parseFloat(data.ProposalAmount) <= 0) {
                alert("Enter Work Amount Greater than 0 !!");
                return;
            }


            let obj = {
                GRNumber: data.GRNumber,
                GRDate: data.GRDate,
                ProposalYear: data.ProposalYear,
                HeadCode: data.HeadCode,
                District: data.District,
                Taluka: data.Taluka,
                ConstituencyName: data.ConstituencyName,
                isMultipleGp: data.isMultipleGp,
                classOfWork: data.workClass,
                typeOfWork: data.workType,
                proposalworkname: data.WorkName,
                roadCategory: data.RoadCategory,
                roadNumber: data.RoadNumber,
                gramPanchayat: data.GramPanchayat,
                proposedLength: data.proposedLength,
                proposalworkamount: data.ProposalAmount,
                remark: data.Remark || "",
                ProposalFileNumber: data.ProposalFileNumber,
                proposalDate: data.proposalDate,
                GRamount: "",
                JobId:data.JobId
            }

            let isDuplicate = tableData.some((entry) =>
                entry.WorkName === obj.proposalworkname &&
                entry.ProposalYear === obj.ProposalYear &&
                entry.HeadCode === obj.HeadCode &&
                entry.District === obj.District &&
                entry.Taluka === obj.Taluka &&
                entry.ConstituencyName === obj.ConstituencyName &&
                entry.isMultipleGp === obj.isMultipleGp &&
                entry.workClass === obj.classOfWork &&
                entry.workType === obj.typeOfWork &&
                entry.RoadCategory === obj.roadCategory &&
                entry.RoadNumber === obj.roadNumber &&
                entry.GramPanchayat === obj.gramPanchayat &&
                entry.proposedLength === obj.proposedLength &&
                entry.ProposalAmount === obj.proposalworkamount &&
                entry.Remark === obj.remark &&
                entry.ProposalFileNumber === obj.ProposalFileNumber &&
                entry.proposalDate === obj.proposalDate &&
                entry.JobId === obj.JobId
            );

            if (isDuplicate) {
                alert("Duplicate entry !! This data already exists in the table.");
                return;
            }

            const updatedTable = [...tableData, obj];
            setTableData(updatedTable);

            const totalAmount = updatedTable.reduce(
                (sum, item) => sum + Number(item.proposalworkamount || 0),
                0
            );


            setData({
                ...data,
                District: "",
                Taluka: "",
                ConstituencyName: "",
                GramPanchayat: [],
                WorkName: "",
                TotalProposalAmount: totalAmount,
                ProposalAmount: "",
                ProposalFileNumber: "",
                Area: "",
                Type: "State",
                workType: '',
                isMultipleGp: 'Yes',
                Remark: "",
                workClass: "",
                RoadCategory: "",
                RoadNumber: "",
                ProposalWorkAmount: "",
                proposedLength: '',
                proposalDate: "",
                GRDate: "",
                proposalDate: "" ,
                JobId:""
            });
            // setData({
            //     ...data,
            //     GramPanchayat: [],
            //     TotalProposalAmount: totalAmount
            // });
            setShowPopup(false);
        }
        catch (err) {
            console.log("Error :: ", err);
        }
    }



    const handleEdit = (e, index) => {
        e.preventDefault();
        const item = tableData[index];
        console.log("table i selected :: ", item)
        setEditIndex(item);
        setIndexofEditing(index);
    };

    const handleDelete = (e, index) => {
        e.preventDefault();
        const updated = tableData.filter((_, i) => i !== index);
        setTableData(updated);
    };

    const handelchangeTablre = (e) => {
        e.preventDefault();
        const updatedData = [...tableData];
        updatedData[Indexofediting] = editIndex;
        setTableData(updatedData);
        console.log("Editted Index :: ", editIndex);
        setEditIndex(null);
        setIndexofEditing(null);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (tableData && tableData.length == 0) {
            return alert("No Entry Added !! Add Entry");
        }

        setLoading(true);
        try {

            const formData = new FormData();
            let updatedTable = [...tableData];

            updatedTable = updatedTable.map(row => {
                const totalGRAmount = updatedTable
                    .filter(item => item.GRNumber === row.GRNumber)
                    .reduce((sum, item) => sum + Number(item.proposalworkamount || 0), 0);

                return {
                    ...row,
                    GRamount: totalGRAmount
                };
            });

            console.log("Updated Table with GRamount: ", updatedTable);
formData.append("Type", "manual");
            formData.append("TotalProposalAmount", data.TotalProposalAmount);
            formData.append("WorkTableData", JSON.stringify(updatedTable));
            // formData.append("ActionType", "CreateProposal");
            let result = await GRProposalCreationFunction(formData);
            const { status, message } = result;
            if (status) {
                alert(message);
                setLoading(false);
                window.location.reload();
            }
            else {
                alert(result);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            alert("Error While Submitting");
            setLoading(false)
            window.location.reload();
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setData(prev => ({ ...prev, GramPanchayat: [] }));
        setShowPopup(false);
    }, [data.isMultipleGp]);



    return (
        <div className='col-12' style={{ height: '91vh', overflowY: 'auto', backgroundColor: "#EFF3F8" }}>
            <div className="col-12 " style={{ padding: '2px 0px 5px 0px' }}>

                <div className="col-12 m-auto my-5 budgetContainer19">
                    <div className="m-auto budgetElement">

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                            <div>
                                <h5 className=''><img src={ProposalCreation32} /> {t("Create GR Proposal")}</h5>
                            </div>
                        </div>

                        <p className='py-2 ps-1 fw-bold text-danger' style={{ backgroundColor: "#FBE7E7" }}>Note : Fields marked with * are mandatory</p>

                        {loading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                                }}>
                                <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                                <style>
                                    {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                </style>
                            </div>
                        )}


                        <div className="col-12 ">
                            <form action="">


                                <div className="col-11 m-auto elements my-2">
                                    <div className="row">
                                        <div className="col-5 my-auto">
                                            <label className='my-auto'>GR Number <span className='text-danger fw-bold'>*</span></label>
                                        </div>
                                        <div className="col-7">
                                            <input type="text" placeholder={t('Enter GR Number')} className='form-control py-2' name='GRNumber'
                                                value={data.GRNumber}
                                                maxLength={50}
                                                onChange={HandleChangeData} />
                                        </div>
                                    </div>
                                </div>


                                <div className="col-11 m-auto elements my-2">
                                    <div className="row">
                                        <div className="col-5">
                                            <label>GR Date</label>
                                        </div>
                                        <div className="col-7">
    <DateInput name="GRDate" value={data.GRDate} onChange={HandleChangeData} maxToday />
</div>
                                    </div>
                                </div>

                                <div className="col-12 my-4">

                                    <div className='m-auto mb-3' style={{ backgroundColor: "white", boxShadow: "0px 0px 5px 1px #E4E8EC", width: "98%", overflowX: "hidden" }}>
                                        <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                                            <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <thead >
                                                    <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                        <th style={{ padding: "7px 10px", minWidth: "150px" }}>Approved Year</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>Head Code</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "150px" }}>District</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "150px" }}>Taluka</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>Constituency Name</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "200px" }}>{t("Multiple Gram Panchayat?")}</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>Class Of Work</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "200px" }}>Type of Work</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "240px" }}>Work Name</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "200px" }}>{t("Job ID")}</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "190px" }}>Road Category</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "200px" }}>Road Number</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>Proposed Length (KM)</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "250px" }}>Gram Panchayat</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>Work Amount</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "240px" }}>Remark</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>Proposal File Number</th>
                                                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Proposal Date")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <tr style={{ backgroundColor: "#E5F4FB", fontSize: "8px" }}>
                                                        <td>
                                                            <select name="ProposalYear"
                                                                value={data.ProposalYear}
                                                                style={{ fontSize: "12px" }}
                                                                className='py-2'
                                                                onChange={(e) => {
                                                                    HandleChangeData(e);
                                                                }}>
                                                                <option value="" disabled>Select Proposal Year</option>
                                                                <option value="2024-2025">2024 - 2025</option>
                                                                <option value="2025-2026">2025 - 2026</option>
                                                                <option value="2026-2027">2026 - 2027</option>
                                                            </select>
                                                        </td>

                                                        <td>
                                                            {/* <select name="HeadCode"
                                                                value={data.HeadCode}
                                                                style={{ fontSize: "12px" }}
                                                                onChange={HandleChangeData}
                                                                className='py-2'
                                                            >
                                                                <option value="" disabled>Choose Head code</option>
                                                                {
                                                                    HeadInfo && (
                                                                        HeadInfo.map((val, index) => {
                                                                            return (
                                                                                <option value={val.HeadID} >{val.HeadName}</option>
                                                                            )
                                                                        })
                                                                    )
                                                                }
                                                            </select> */}
                                                             <select name="HeadCode" value={data.HeadCode} className='py-2' onChange={HandleChangeData}   style={{ fontSize: "12px" }}>
                                                                
                                {HeadInfo &&
                                  HeadInfo
                                    .filter(val =>
                                      RoleID === 25 || RoleID === 24
                                        ? val.HeadName === "3054-2419(Roads and bridge repair maintenance program)"
                                        : val.HeadName === "2515-1238(MLA Representative)"
                                    )
                                    .map(val => (
                                   <option value={val.HeadID} >{t(val.HeadName)}</option>
                                    ))
                                }
                              </select>
                                                        </td>

                                                        <td>
                                                            <select name="District" value={data.District} className='py-2' onChange={HandleChangeData} style={{ fontSize: "12px" }} required>
                                                                <option value="" disabled>Choose District</option>
                                                                {
                                                                    AllDistrict &&
                                                                    [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
                                                                        return (
                                                                            <option key={index} value={district}>{district}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </td>

                                                        <td>
                                                            <select name="Taluka" value={data.Taluka} className='py-2' onChange={HandleChangeData} style={{ fontSize: "12px" }} required>
                                                                <option value="" disabled>Choose Taluka</option>
                                                                {
                                                                    TalukasofDistrict.length > 0 &&
                                                                    TalukasofDistrict.map((val, index) => {
                                                                        return (
                                                                            <option key={index} value={val.ULBNameMarathi}>{val.ULBNameMarathi}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </td>

                                                        <td>
                                                            <input type="text" placeholder={t('Enter Constituency Name')} className='py-2' name='ConstituencyName'
                                                                maxLength={100}
                                                                value={data.ConstituencyName}
                                                                onChange={HandleChangeData}
                                                                style={{ fontSize: "12px" }}
                                                                // onChange={(e) => {
                                                                //     const value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                                                                //     HandleChangeData({ target: { name: e.target.name, value } });
                                                                // }}
                                                                required />
                                                        </td>

                                                        <td>
                                                            <select name="isMultipleGp" value={data.isMultipleGp} className='py-2' onChange={HandleChangeData} style={{ fontSize: "12px" }} required>
                                                                <option value="Yes">Yes</option>
                                                                <option value="No">No</option>
                                                            </select>
                                                        </td>

                                                        <td>
                                                            <select name="workClass" id=""
                                                                value={data.workClass}
                                                                onChange={HandleChangeData}
                                                                style={{ fontSize: "12px" }}
                                                                className='py-2'
                                                            >
                                                                <option value="" >Choose Class Of Work</option>
                                                                {WorkId && [...new Set(WorkId.map(item => item.Work_Type))].sort().map((val, index) => (
                                                                    <option key={index} value={val}>{val || "N/A"}</option>
                                                                ))}
                                                            </select>
                                                        </td>

                                                        <td>
                                                            <select name="workType" id=""
                                                                value={data.workType}
                                                                onChange={HandleChangeData}
                                                                style={{ fontSize: "12px" }}
                                                                className='py-2'
                                                            >
                                                                <option value="">Choose Type of Work</option>
                                                                {getWork && getWork.map((val, index) => {
                                                                    return (
                                                                        <option key={index} value={val.Work_name}>{val.Work_name}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                name="WorkName"
                                                                placeholder={t("Enter Work Name")}
                                                                style={{ fontSize: "12px" }}
                                                                className='py-2'
                                                                value={data.WorkName}
                                                                onChange={HandleChangeData}
                                                                required
                                                            />
                                                        </td>
<td>
<input
                                                                type='number'
                                                                name="JobId"
                                                                pattern="[0-9]*"
                                                                placeholder={t("Enter Job Id here")}
                                                              className='py-2'
                                                                style={{ fontSize: "12px" }}
                                                                value={data.JobId}
                                                                maxLength={12}
                                                                onChange={(e) => {
                                                                    let value = e.target.value.replace(/\D/g, "");
                                                                    HandleChangeData({
                                                                        target: { name: "JobId", value },
                                                                    });
                                                                }}
                                                                required
                                                            />
                                                        </td>
                                                        <td>
                                                            {/* <input
                                                                type="text"
                                                                name="RoadCategory"
                                                                placeholder="Enter Category"
                                                                className="form-control"
                                                                value={data.RoadCategory}
                                                                onChange={HandleChangeData}
                                                                required
                                                            /> */}

                                                            <select name="RoadCategory" id=""
                                                                value={data.RoadCategory}
                                                                onChange={HandleChangeData}
                                                                className='py-2'
                                                                style={{ fontSize: "12px" }}
                                                                required
                                                            >
                                                                <option value="" disabled>Choose Road Category</option>
                                                                <option>Village Road</option>
                                                                <option>Other District Road</option>
                                                            </select>
                                                        </td>
                                                        
                                                        <td>
                                                            <input
                                                                type="text"
                                                                name="RoadNumber"
                                                                placeholder={t("Enter Road No.")}
                                                                className='py-2'
                                                                style={{ fontSize: "12px" }}
                                                                value={data.RoadNumber}
                                                                // onChange={HandleChangeData}
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/[^0-9]/g, "");
                                                                    HandleChangeData({ target: { name: e.target.name, value } });
                                                                }}
                                                                required
                                                            />
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                name="proposedLength"
                                                                placeholder={t("Enter Proposed Length")}
                                                                className='py-2'
                                                                style={{ fontSize: "12px" }}
                                                                value={data.proposedLength}
                                                                // onChange={HandleChangeData}
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/[^0-9]/g, "");
                                                                    HandleChangeData({ target: { name: e.target.name, value } });
                                                                }}
                                                                required
                                                            />
                                                        </td>

                                                        <td >
                                                            <div className="col-12" style={{ fontSize: "12px" }}>
                                                                {
                                                                    (showPopup == false && data.GramPanchayat.length <= 0) &&
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            if (!data.Taluka || !data.isMultipleGp || !data.HeadCode) {
                                                                                alert("Plz Fill Above Missing Data !!");
                                                                            } else {
                                                                                setShowPopup(true)
                                                                            }
                                                                        }}
                                                                        className='btn btn-success py-1 px-4'
                                                                    >
                                                                        Select Gram Panchayat
                                                                    </button>
                                                                }

                                                                {
                                                                    (data.GramPanchayat.length > 0) && (
                                                                        <div className="col-12" style={{ overflowX: "hidden", overflowWrap: "break-word", whiteSpace: "normal" }} disabled={data.HeadCode}>
                                                                            {data.GramPanchayat.join(", ")}
                                                                        </div>
                                                                    )
                                                                }

                                                            </div>

                                                        </td>


                                                        <td>
                                                            <input
                                                                type="text"
                                                                name="ProposalAmount"
                                                                placeholder={t("Enter Work Amount")}
                                                                className='py-2'
                                                                style={{ fontSize: "12px" }}
                                                                min="0"
                                                                value={data.ProposalAmount}
                                                                onKeyDown={(e) => {
                                                                    if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
                                                                }}
                                                                // onChange={HandleChangeData}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                        HandleChangeData(e);
                                                                    }
                                                                }}
                                                                required
                                                            />
                                                        </td>

                                                        <td>

                                                            <input
                                                                type="text"
                                                                name="Remark"
                                                                placeholder={t("Enter Remark")}
                                                                className='py-2'
                                                                style={{ fontSize: "12px" }}
                                                                value={data.Remark}
                                                                onChange={HandleChangeData}
                                                                required
                                                            />

                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                placeholder={t('Enter Proposal File Number')}
                                                                className=' py-2'
                                                                name='ProposalFileNumber'
                                                                style={{ fontSize: "12px" }}
                                                                value={data.ProposalFileNumber}
                                                                onChange={HandleChangeData} />

                                                        </td>
                                                        <td>
    <DateInput name="proposalDate" value={data.proposalDate} onChange={HandleChangeData} maxToday small />
</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {
                                    showPopup && (
                                        <div
                                            style={{
                                                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.21)', backdropFilter: 'blur(4px)', zIndex: 999,
                                                display: 'flex', justifyContent: 'center', alignItems: 'center'
                                            }}
                                        >
                                            <div className="m-auto" style={{
                                                background: "white",
                                                height: '400px',
                                                width: "450px",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                                padding: "20px"
                                            }}>
                                                <div style={{ position: "relative" }}>
                                                    <button
                                                        type="button"
                                                        // onClick={() => setShowPopup(false)}
                                                        onClick={() => {
                                                            if (data.isMultipleGp == "Yes") {
                                                                if (data.GramPanchayat.length < 2) {
                                                                    alert("Minimum of 2 Gram Panchayats should be Selected !");
                                                                    return;
                                                                }
                                                            }
                                                            setShowPopup(false);
                                                        }}

                                                        style={{
                                                            padding: "5px 15px",
                                                            fontSize: "13px",
                                                            borderRadius: "3px",
                                                            border: "none",
                                                            backgroundColor: "#2ff01aff",
                                                            color: "#fff",
                                                            cursor: "pointer",
                                                            fontWeight: "500"
                                                        }}
                                                    >
                                                        {t("Save")}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        // onClick={() => setShowPopup(false)}
                                                        onClick={() => {
                                                            setData({
                                                                ...data,
                                                                GramPanchayat: []
                                                            });
                                                            setShowPopup(false);
                                                        }}
                                                        style={{
                                                            padding: "5px 10px",
                                                            fontSize: "18px",
                                                            borderRadius: "3px",
                                                            border: "none",
                                                            backgroundColor: "#b60101",
                                                            color: "#fff",
                                                            cursor: "pointer",
                                                            fontWeight: "600",
                                                            lineHeight: "1",
                                                            float: "right"
                                                        }}
                                                        title="Close"
                                                    >
                                                        &times;
                                                    </button>
                                                </div>

                                                <div className="col-12">
                                                    {[...new Set(gramPanchayat.map(gp => gp.Village_Panchayat_Name))].map((name, index) => (
                                                        <div className='col-12' key={index} style={{ marginBottom: "5px", fontSize: "12px" }}>
                                                            <div className="row">
                                                                <div className="col-2 m-auto">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`gp-${index}`}
                                                                        value={name}
                                                                        checked={data.GramPanchayat.includes(name)}
                                                                        style={{
                                                                            margin: "auto"
                                                                        }}
                                                                        onChange={(e) => {

                                                                            if (data.isMultipleGp == 'No') {
                                                                                setData(prev => ({ ...prev, GramPanchayat: [name] }));
                                                                                setShowPopup(false);
                                                                            }
                                                                            else {
                                                                                if (e.target.checked) {
                                                                                    if (data.GramPanchayat.length >= 5) {
                                                                                        alert("You can select a maximum of 5 Gram Panchayats only.");
                                                                                        setShowPopup(false);
                                                                                        return;
                                                                                    }
                                                                                    setData(prev => ({ ...prev, GramPanchayat: [...prev.GramPanchayat, name] }));
                                                                                } else {
                                                                                    setData(prev => ({ ...prev, GramPanchayat: prev.GramPanchayat.filter(gp => gp !== name) }));
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="col-10 m-auto">
                                                                    <label className='col-12 my-auto' htmlFor={`gp-${index}`}>{name}</label>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    ))}

                                                    {/* Close Button */}
                                                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (data.isMultipleGp == "Yes") {
                                                                    if (data.GramPanchayat.length < 2) {
                                                                        alert("Minimum of 2 Gram Panchayats should be Selected !");
                                                                        return;
                                                                    }
                                                                }
                                                                setShowPopup(false);
                                                            }}
                                                            style={{
                                                                padding: "5px 15px",
                                                                fontSize: "13px",
                                                                borderRadius: "3px",
                                                                border: "none",
                                                                backgroundColor: "#b60101ff",
                                                                color: "#fff",
                                                                cursor: "pointer",
                                                                fontWeight: "500"
                                                            }}
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    )
                                }

                                <div className="col-12 text-end mb-4">
                                    <div className="col-10 m-auto">
                                        <button style={{ backgroundColor: '#f9a318', width: "6rem", color: 'white', border: 'none', borderRadius: '5px', height: '2rem' }} onClick={AddinTableOperation}>ADD</button>
                                    </div>
                                </div>

                                {
                                    tableData &&
                                    tableData.length > 0 &&
                                    (
                                        <div className="col-12 my-5">
                                            <div className='m-auto mb-3' style={{ backgroundColor: "white", boxShadow: "0px 0px 5px 1px #E4E8EC", width: "98%", overflowX: "hidden" }}>
                                                <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                                                    <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                        <thead>
                                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>

                                                                <th style={{ padding: "7px 10px", minWidth: "40px" }}>Sr.No</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "150px" }}>GR Number</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "150px" }}>Approved Year</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Head Code</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "150px" }}>District</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "150px" }}>Taluka</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Constituency Name</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "200px" }}>{t("Multiple Gram Panchayat?")}</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Class Of Work</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "200px" }}>Type of Work</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "240px" }}>Work Name</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "240px" }}>Job ID</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "190px" }}>Road Category</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "200px" }}>Road Number</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Proposed Length (KM)</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "250px" }}>Gram Panchayat</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Work Amount</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "240px" }}>Remark</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Proposal File Number</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Proposal Date")}</th>
                                                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>GR Date</th>
                                                                {/* <th style={{ padding: "7px 10px", minWidth: "180px" }}>Actions</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                tableData.map((val, index) => {
                                                                    return (
                                                                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem', fontSize: "18px" }}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{val.GRNumber}</td>
                                                                            <td>{val.ProposalYear}</td>
                                                                            <td>{val.HeadCode}</td>
                                                                            <td>{val.District}</td>
                                                                            <td>{val.Taluka}</td>
                                                                            <td>{val.ConstituencyName}</td>
                                                                            <td>{val.isMultipleGp}</td>
                                                                            <td>{val.classOfWork}</td>
                                                                            <td>{val.typeOfWork}</td>
                                                                            <td>{val.proposalworkname}</td>
                                                                            <td>{val.JobId}</td>
                                                                            <td>{val.roadCategory}</td>
                                                                            <td>{val.roadNumber}</td>
                                                                            <td>{val.proposedLength}</td>
                                                                            <td>
                                                                                <div className="col-12" style={{ overflowX: "hidden", overflowWrap: "break-word", whiteSpace: "normal" }}>
                                                                                    {val.gramPanchayat.join(", ")}
                                                                                </div>
                                                                            </td>
                                                                            <td>{val.proposalworkamount}</td>
                                                                            <td>{val.remark}</td>
                                                                            <td>{val.ProposalFileNumber}</td>
                                                                            <td>{val.proposalDate ? moment(val.proposalDate).format("DD/MM/YYYY") : "-"}</td>
                                                                            <td>{val.GRDate ? moment(val.GRDate).format("DD/MM/YYYY") : "-"}</td>
                                                                            {/* <td>
                                                                                <button className="btn btn-sm btn-primary mx-1" onClick={(e) => handleEdit(e, index)}>Edit</button>
                                                                                <button className="btn btn-sm btn-danger mx-1" onClick={(e) => handleDelete(e, index)}>Delete</button>
                                                                            </td> */}
                                                                        </tr>

                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }



                                {/* {
                                    editIndex &&
                                    <div style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        background: "rgba(0, 0, 0, 0.4)",
                                        backdropFilter: "blur(6px)",
                                        zIndex: 100,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        animation: "fadeIn 0.3s ease-in-out",
                                    }}>
                                        <div className="col-6 shadow-lg rounded-4 p-4 bg-white border-0 m-auto">
                                            <div className="col-12 m-auto rounded p-4 border border-dark">
                                                <form action="">
                                                    <div className="row">

                                                        <div className="col-12 my-2">
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <label>Proposal Work Name </label>
                                                                </div>

                                                                <div className="col-6">
                                                                    <input type="text" value={editIndex.proposalworkname} disabled />
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="col-12 my-2">
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <label>Proposal Work Amount </label>
                                                                </div>

                                                                <div className="col-6">
                                                                    <input type="text" value={editIndex.proposalworkamount} name='amount' onChange={(e) => setEditIndex({ ...editIndex, proposalworkamount: e.target.value })} />
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="col-12 my-4 text-center">
                                                            <button className='btn btn-success px-5 fw-bold' onClick={(e) => handelchangeTablre(e)}>Submit</button>
                                                        </div>

                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                } */}


                                <div className="col-12 ms-auto my-4">
                                    <div className="row">
                                        <div className="col-5"></div>
                                        <div className="col-7">
                                            <div className="col-12" style={{ display: 'flex', gap: '10px' }}>
                                                <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '7rem', height: '2rem', fontSize: '18px' }} onClick={handleSubmit}><img src={submit} style={{ width: '15px' }} /> Save</button>
                                                {/* <button type="button"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '4px',
                                                        backgroundColor: '#f1594c',
                                                        width: '6rem', height: '2rem', fontSize: '16px'
                                                    }}
                                                    onClick={() => CancelMapSubmission()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </form>
                        </div>


                    </div>
                </div >
            </div >
        </div >
    )
}

export default GRProposalCreation;